import { observer } from 'mobx-react-lite';
import {
  WebGameColumn,
  useTranslation,
  WebGameMainCont,
  WebGameColumnInner,
} from '@pascal/pascal-core';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';

import WebGame from './webGame';
import LeftColumn from '../common/leftColumn';
import RightColumn from '../common/rightColumn';
import hiLoLogo from '../../assets/images/game/logo.png';
import { PopupsWrapper } from '../common/popUps/wrapper';
import { BonusIslandMap } from '../common/bonusIslandMap';
import BonusIslandWeb from '../../components/web/bonusIsland';
import { bonusIslandStore } from '../../store/bonusIslandStore';
import BonusIslandInfoModalWeb from '../../components/web/bonusIsland/infoModal';
import playForRealPopupImgSrc from '../../assets/images/core/play-for-real-popup.png';

const Web = observer(() => {
  const t = useTranslation();
  const {
    isBonusIslandOpen,
    ranges: currentRanges,
    selectedRange,
    setIsBonusIslandOpen,
    getCurrentBonusIslandData,
  } = bonusIslandStore;
  const { currencyCode, currencySymbolOrCode } = userInfoStore;
  const { endDate, startDate, status, ranges = [] } = currentRanges;
  const {
    data: { selections = [] },
    isLoading,
  } = selectedRange;
  return (
    <>
      <WebGameMainCont
        hasDemoPopup
        lobbyLogoImageSrc={hiLoLogo}
        playForRealPopupImgSrc={playForRealPopupImgSrc}
        isShowBogLineLobby
        isShowIconTag
      >
        <LeftColumn />
        <WebGameColumn position='center'>
          <WebGameColumnInner position='center'>
            <WebGame />
          </WebGameColumnInner>
          <PopupsWrapper />
        </WebGameColumn>
        <RightColumn />
        {isBonusIslandOpen && (
          <BonusIslandMap
            t={t}
            loading={isLoading}
            tournamentStatus={status}
            tournamentRanges={ranges}
            innerComp={BonusIslandWeb}
            currencyCode={currencyCode}
            currency={currencySymbolOrCode}
            tournamentEndDate={endDate}
            setIsOpen={setIsBonusIslandOpen}
            tournamentStartDate={startDate}
            tournamentSelections={selections}
            innerCompModal={BonusIslandInfoModalWeb}
            getTournamentDataAction={getCurrentBonusIslandData}
          />
        )}
      </WebGameMainCont>
    </>
  );
});

export default Web;
